import Web3 from "./web3.js";
import {ethers} from 'ethers'


const chainlist = {
    1: "ethereum-mainnet",
    3: "ethereum-ropsten",
    4: "ethereum-rinkeby",
    5: "ethereum-goerloi",
    10: "ethereum-optimism",
    56: "ethereum-bsc",
    97: "ethereum-bsctestnet",
    137: "ethereum-matic",
    250: "ethereum-fantom",
    43114: "ethereum-avalanche",
    42161: "ethereum-arbitrum",
    80001: "ethereum-mumbai",
}

// create a reverse lookup
const chainLookup = {}
Object.keys(chainlist).forEach( (key) => {
    chainLookup[chainlist[key]] = key
})

import PA from "@proveanything/base"

import contracts from "../contracts/index.js"

class NFTContext {

    contructor() {

    }

    async init(params) {

        this.loading = true
        // get the proof group
        try {
            this.proofGroup = await PA.Core.ProofGroup.get(params.site, params.proofGroup)
        } catch (err){
            console.error("ProofGroup not found", err)
            this.loading = false
            return
        }



        if (!this.proofGroup || !this.proofGroup.id){
            console.error("ProofGroup not found", this.proofGroup)
            this.loading = false
            return
        }

        // setup basic data
        this.callback = params.callback
     //   this.window = params.window
        
        this.mintPrice = this.proofGroup.settings.mintPrice
        this.ccy = this.proofGroup.settings.ccy || "ETH"
        this.mintMax = this.proofGroup.settings.mintMax || 4
        this.maxAccesslistMint = this.proofGroup.settings.maxAccesslistMint || 2
        this.accesslist = this.proofGroup.settings.accesslist
        this.contractAddress = this.proofGroup.chain.contract
        this.altCcyContract = this.proofGroup.chain.altCcyContract
        this.multichain = this.proofGroup.chain.multichain
        this.gasLimit = this.proofGroup.settings.gasLimit

        if (this.proofGroup.settings.altMintPrice){
            this.hasAltMint = true
            this.altMintPrice = this.proofGroup.settings.altMintPrice
            this.altCcy = this.proofGroup.settings.altCcy
        }
        if (this.mintPrice){
          this.ethPrice = ethers.utils.formatUnits(""+this.mintPrice, 'ether');
        }

        // we now support multi-chains - so first create this main chain
        this.allowedChains = {}
        this.allowedChains[chainLookup[this.proofGroup.chain.chain]] = {
            contract: this.contractAddress,
            ccy: this.ccy,
            mintMax: this.mintMax,
            maxAccesslistMint: this.maxAccesslistMint,
            ethPrice: this.ethPrice,
            mintPrice: this.mintPrice,
            altMintPrice: this.altMintPrice,
            altCcy: this.altCcy,
            altCcyContract: this.altCcyContract
        }

        // now add other chains...if needed
        if (this.multichain && this.proofGroup.chain.altChains){
            this.proofGroup.chain.altChains.forEach( (chain) => {
                this.allowedChains[chainLookup[chain.chain]] = {
                    contract: chain.contract,
                    ccy: chain.ccy,
                    mintMax: chain.mintMax || this.mintMax,
                    maxAccesslistMint: chain.maxAccesslistMint || this.maxAccesslistMint,
                    ethPrice: ethers.utils.formatUnits(""+chain.mintPrice, 'ether'),
                    mintPrice: chain.mintPrice,
                    altMintPrice: this.mintPrice,
                    altCcy: chain.altCcy,
                    altCcyContract: chain.altCcyContract
                }
            })
        }

        //     console.log(this.allowedChains)

        if (window.ethereum) {
            this.handleEthereum();
        } else {
            window.addEventListener('ethereum#initialized', this.handleEthereum, {
            once: true,
            });
        
            // If the event is not dispatched by the end of the timeout,
            // the user probably doesn't have MetaMask installed.
            setTimeout(this.handleEthereum, 3000); // 3 seconds
        }

        return this
    }

    async handleEthereum() {

        // check if web3 is defined
        if (typeof window.ethereum === 'undefined') {
            console.warn('No web3 wallet is installed!');
            this.hasWeb3 = false
            this.loading = false
            return
        }
        this.hasWeb3 = true
    
        // connect if we forced them to
  //      if (params.forceConnect){
  //          this.account = await Web3.connectWeb3()
  //      }
          
        try {
            window.ethereum.sendAsync({
                method: "eth_accounts",
                params: [],
                jsonrpc: "2.0",
                id: new Date().getTime()
                } , async  (error, result) => {
                  if (error){
                    console.error("sendAsnyc had an error", error, result)
                    if (this.callback){
                        this.callback( "ERROR", error)                    
                    }
                    this.notConnected = true
                  } else if (result.result.length == 0){
                    // no account found - set it to null
                    this.account = null
                    if (this.callback){
                        this.callback( "SET_ACCOUNT", {account: this.account})                    
                    }
                    this.notConnected = true
                  } else {
                      this.account = result.result[0]
                      if (this.callback){
                          this.callback( "SET_ACCOUNT", {account: this.account})
                      }
                  }

                });
              } catch(err) {
                console.err("Error connecting:", err)
              }
    
        window.ethereum.on('chainChanged', (chainId) => {
          this.chainId = parseInt(chainId, 16);
          if (this.allowedChains[this.chainId]){
            this.setCurrentChain(this.allowedChains[this.chainId])
            this.correctChain = true
          } else {
            this.correctChain = false
          }
          if (this.callback){
            this.callback( "CHAIN_CHANGED", {chainId: this.chainId, correctChain: this.correctChain})
            }
            if (this.correctChain){
                // if we're on the correct chain - go lookup some chain values
                this.getContractValues(new ethers.providers.Web3Provider(window.ethereum))
            }
        });

        window.ethereum.on('accountsChanged',  (accounts) => {
            this.account = accounts[0]
            if (this.callback){
                this.callback( "SET_ACCOUNT", {account: this.account})
            }      
          })
  
          window.ethereum.on('message', (message) => {
            if (this.callback){
                this.callback( "MESSAGE", {message: message})
            }      
          });
  
        
        const provider = new ethers.providers.Web3Provider(window.ethereum)

      
        const network = await provider.getNetwork();
        this.chainId = network.chainId
        this.chainName =  network.name

        if (this.allowedChains[this.chainId]){
            this.setCurrentChain(this.allowedChains[this.chainId])
            this.correctChain = true
        } else {
          this.correctChain = false
          this.loading = false
          return 
        }

        await this.getContractValues(provider)

        this.loading = false
    
        return this
    }
    setCurrentChain(chain){
        this.contractAddress = chain.contract;
        this.ccy = chain.ccy
        this.mintMax = chain.mintMax
        this.maxAccesslistMint = chain.maxAccesslistMint
        this.ethPrice = chain.ethPrice
        this.mintPrice = chain.mintPrice
        this.altMintPrice = chain.altMintPrice
        this.altCcy = chain.altCcy
        this.altCcyContract = chain.altCcyContract
    }

    async connectWallet(){
        this.account = await Web3.connectWeb3()
        return this.account
    }
    async getContractValues(provider, attempt = 0){

        try {
            let nftContract = contracts.load(provider, {
                contract: this.contractAddress,
                contractType: this.proofGroup.chain.contractType
            });
    
            this.totalMinted = (await  nftContract.totalSupply()).toNumber()
                   
            this.total = (await  nftContract.maxSupply()).toNumber() 

            // mark if we think it's sold out
            if (this.totalMinted >= this.total){
                this.isSold = true
            } else {
                this.isSold = false
            }

            // confirm what the contract says is the max mint
            if (nftContract.maxTokenPurchase)
                this.mintMax = (await  nftContract.maxTokenPurchase()).toNumber() 

           
            this.mintPrice = (await  nftContract.basePrice())
            this.ethPrice = ethers.utils.formatUnits(""+this.mintPrice, 'ether');

        
            // is there a public sale flag - if not just mark as live
            if ( nftContract.publicSaleActive)
                this.publicSaleActive = await  nftContract.publicSaleActive()
            else
                this.publicSaleActive = true

            // is there a whtelist sale flag - if not just mark as no-accesslist
            if ( nftContract.accesslistSaleActive){
                this.accesslistSaleActive = await  nftContract.accesslistSaleActive()
                if ( nftContract.maxAccesslistPurchase)
                  this.maxAccesslistMint = (await  nftContract.maxAccesslistPurchase()).toNumber() 
                this.accessListMintPrice = (await  nftContract.accesslistPrice())
                this.ethAccessListPrice = ethers.utils.formatUnits(""+this.accessListMintPrice, 'ether');
                if (this.accesslistSaleActive && !this.publicSaleActive){
                    this.mintMax = this.maxAccesslistMint
                    this.mintPrice = this.accessListMintPrice
                    this.ethPrice = this.ethAccessListPrice
                }
            } else {
                this.accesslistSaleActive = false

            }

            // is there an alt mint price (i.e. WETH)
            if ( this.altCcy){
                this.altMintPrice = (await  nftContract.basePriceEth())
                this.altEthPrice = ethers.utils.formatUnits(""+this.altMintPrice, 'ether');
                this.altCcyContract = (await nftContract.altCcyContract())
            } else {
                this.altMintPrice = null
                this.altEthPrice = null
            }

            // if only the access list is open - then set the max mint to whatever the access list limit is
       //     console.log(this)

            if (this.callback){
                this.callback( "UPDATED_CONTRACT", {
                    total: this.total,
                    totalMinted: this.totalMinted,
                    publicSaleActive: this.publicSaleActive,
                    accesslistSaleActive: this.accesslistSaleActive,
                    isSold: this.isSold,
                    mintMax: this.mintMax
                })
            }   

          } catch (error) {
            if (error.code == -32603){
                if (attempt == 0){
                    console.warn("Contract fetch issue from metamask - trying again")
                    this.getContractValues(provider, 1);
                } else {
                    console.warn("Contract fetch issue from metamask - giving up", error)
                    if (this.callback){
                      this.callback( "CONTRACT_FETCH_FAILED", error)
                    }
                }
            } else {
                console.error("Contact error:", error)
                if (this.callback){
                    this.callback( "CONTRACT_FETCH_FAILED", error)
                }
            }

          }        

    }

    async mint(mintNumber){
        // is the mint even enabled?
        if (!this.shouldShowPublicMint(true)){
            // no pubic mint - what about an accesslist mint ?
            if (this.shouldShowAccesslistMint(true)){
                return this.accesslistMint(mintNumber)
            } else {
                // can't mint anything
                if (this.callback){
                    this.callback("MINT_DISABLED")
                }
                return
            }
        }
        const provider = new ethers.providers.Web3Provider(window.ethereum)
    
        const signer = provider.getSigner()

    
        let myContract = contracts.load(signer, {
            contract: this.contractAddress,
            contractType: this.proofGroup.chain.contractType
        });
        // a flag that an overall mint action is running
        this.mintRunning = true

        // a flag that a pending mint is waiting on a wallet interaction
        this.waitingOnWallet = true

        try {
            const weiPrice = this.mintPrice * mintNumber;
    
            const gasPrice = await provider.getGasPrice( )

            if (this.callback){
                this.callback("MINT_STARTED", {gasPrice: gasPrice})
            }

            let response = await myContract.mint(""+mintNumber, {
                    from: this.account,
                    value: ""+ weiPrice,
                    gasPrice: gasPrice,
                    gasLimit: this.getGasLimit(),
                }) 

            // no longer waiting on the wallet
            this.waitingOnWallet = false    

            if (this.callback){
                this.callback("MINT_PENDING", {tx: response})
            }

            const res = await response.wait()
            this.mintRunning = false

            if (res.status == 1){
                if (this.callback){
                    this.callback("MINT_SUCCEEDED", {tx: res})
                }
            } else {
                if (this.callback){
                    this.callback("MINT_FAILED", {tx: res})
                }
            }

            // update the total in teh background
            this.getContractValues(provider)


            return res

        } catch (err) {
            this.mintRunning = false
            this.waitingOnWallet = false
            // look for rejection errors
            if (this.callback){
                if (err.code && err.code == 4001)
                    this.callback("USER_REJECTED", {message: err.message})
                else
                    this.callback("CONTRACT_CALL_ERROR", {message: err.message})
            } else {
                console.error(err.message)
            }

            return null
        }
    
        
    }
    getGasLimit() {
        // if we're on ETH mainnet - don't enter a gas limit - otherwise enter one
        if (this.chainId == 1)
          return null
        // allow it to be set - or default it to 100000
        return this.gasLimit || "100000"
    }

    async altMint(mintNumber){
        // is the mint even enabled?
        if (!this.shouldShowPublicMint(true)){
            // no pubic mint - what about an accesslist mint ?
            if (this.shouldShowAccesslistMint(true)){
                return this.accesslistMint(mintNumber)
            } else {
                // can't mint anything
                if (this.callback){
                    this.callback("MINT_DISABLED")
                }
                return
            }
        }
        const provider = new ethers.providers.Web3Provider(window.ethereum)
    
        const signer = provider.getSigner()

        let wethContract = contracts.load(signer, {
            contractType: "WETH",
            contract: this.altCcyContract
        });

    
        let myContract = contracts.load(signer, {
            contract: this.contractAddress,
            contractType: this.proofGroup.chain.contractType
        });

        // a flag that an overall mint action is running
        this.mintRunning = true

        // a flag that a pending mint is waiting on a wallet interaction
        this.waitingOnWallet = true

        try {
            const weiPrice = this.altMintPrice * mintNumber;


    
            const gasPrice = await provider.getGasPrice( )

            if (this.callback){
                this.callback("MINT_STARTED", {gasPrice: gasPrice})
            }

            var count = await provider.getTransactionCount(this.account);

   //         console.log("count", count, count+1)
            
            let wethPendingResponse = wethContract.approve(this.contractAddress, ""+weiPrice, {
                from: this.account,
                value: "0",
                gasPrice: gasPrice,
                gasLimit: this.getGasLimit(),
                nonce:  ethers.utils.hexlify(count), 
            }) 

            if (this.callback){
                wethPendingResponse.then( (wethResponse) => {
                    this.callback("WETH_PENDING", {tx: wethResponse})
                } )
            }            

            let response = await myContract.mintWeth(""+mintNumber, {
                    from: this.account,
                    value: "0",
                    gasPrice: gasPrice,
                    gasLimit: this.getGasLimit(),
                    nonce:  ethers.utils.hexlify(count+1)
                }) 

            // no longer waiting on the wallet
            this.waitingOnWallet = false    

            if (this.callback){
                this.callback("MINT_PENDING", {tx: response})
            }

            const res = await response.wait()
            this.mintRunning = false

            if (res.status == 1){
                if (this.callback){
                    this.callback("MINT_SUCCEEDED", {tx: res})
                }
            } else {
                if (this.callback){
                    this.callback("MINT_FAILED", {tx: res})
                }
            }

            // update the total in teh background
            this.getContractValues(provider)


            return res

        } catch (err) {
            this.mintRunning = false
            this.waitingOnWallet = false
            // look for rejection errors
            if (this.callback){
                if (err.code && err.code == 4001)
                    this.callback("USER_REJECTED", {message: err.message})
                else
                    this.callback("CONTRACT_CALL_ERROR", {message: err.message})
            } else {
                console.error(err.message)
            }

            return null
        }
    
        
    }

    async checkIfAccessList(){
        if (!this.accesslist || !this.account)
            return false

        const result = await PA.Core.ProofGroup.Accesslist.getProof(this.proofGroup.site, this.proofGroup.id, "default", this.account)     
        
        return result && result.proof && result.proof.length > 0
    }

    async accesslistMint(mintNumber){
        const provider = new ethers.providers.Web3Provider(window.ethereum)
    
        const signer = provider.getSigner()
    
        let myContract = contracts.load(signer,  {
            contract: this.contractAddress,
            contractType: this.chain.contractType
        });

        // a flag that an overall mint action is running
        this.mintRunning = true

        // a flag that a pending mint is waiting on a wallet interaction
        this.waitingOnWallet = true

        try {
    
            const weiPrice = this.mintPrice * mintNumber;
    
            const gasPrice = await provider.getGasPrice( )

            if (this.callback){
                this.callback("MINT_STARTED", {gasPrice: gasPrice})
            }

            // get the merkle proof for the whitelist mint
            const result = await PA.Core.ProofGroup.Accesslist.getProof(this.proofGroup.site, this.proofGroup.id, "default", this.account)   
            if (!result.proof || result.proof.length == 0 && this.callback){
                this.callback( "ACCESSLIST_PROOF_FAILED", {account: this.account, type: "default"})    
                this.mintRunning = false
                this.waitingOnWallet = false
                return null
            }

            let response = await myContract.accesslistMint(""+mintNumber, result.proof, {
                    from: this.account,
                    value: ""+ weiPrice,
                    gasPrice: gasPrice,
                    gasLimit: this.getGasLimit()
                }) 

            // no longer waiting on the wallet
            this.waitingOnWallet = false    

            if (this.callback){
                this.callback("MINT_PENDING", {tx: response})
            }

            const res = await response.wait()
            this.mintRunning = false

            if (res.status == 1){
                if (this.callback){
                    this.callback("MINT_SUCCEEDED", {tx: res})
                }
            } else {
                if (this.callback){
                    this.callback("MINT_FAILED", {tx: res})
                }
            }

            // update the total in teh background
            this.getContractValues(provider)


            return res

        } catch (err) {
            this.mintRunning = false
            this.waitingOnWallet = false
            // look for rejection errors
            if (this.callback){
                if (err.code && err.code == 4001)
                    this.callback("USER_REJECTED", {message: err.message})
                else
                    this.callback("CONTRACT_CALL_ERROR", {message: err.message})
            } else {
                console.error(err.message)
            }

            return null
        }
    
        
    }

    // helper function that tells you if you should show a connect button
    shouldShowConnect(){
        return this.hasWeb3 && this.correctChain && !this.account
    }

    // helper function that tells you if you should show a mint button
    shouldShowMint(allowMultiple = true){
        return this.hasWeb3          // web 3 is enabled
            && this.correctChain     // and we have the right network selected
            && this.account          // and the web3 wallet is connected
            && !this.isSold          // and it's not sold out
            && (this.publicSaleActive || this.accesslistSaleActive) // and the any sale is active
            && !this.waitingOnWallet // shouldn't be able to press mint while we're waiting on a wallet interaction
            && (!this.mintRunning || allowMultiple)     // can't mint if we'd said they cannot do a mint when another mint tx is pending
    }



    // helper function that tells you if you should show a mint button
    shouldShowPublicMint(allowMultiple = true){
        return this.hasWeb3          // web 3 is enabled
            && this.correctChain     // and we have the right network selected
            && this.account          // and the web3 wallet is connected
            && !this.isSold          // and it's not sold out
            && this.publicSaleActive // and the public sale is active
            && !this.waitingOnWallet // shouldn't be able to press mint while we're waiting on a wallet interaction
            && (!this.mintRunning || allowMultiple)     // can't mint if we'd said they cannot do a mint when another mint tx is pending
    }


    // helper function that tells you if you should show a mint button
    // current not support for allow list - only for public mints
    shouldShowAltPublicMint(allowMultiple = true){
        return this.shouldShowPublicMint(allowMultiple)     // basic public mint is enabled
            && this.altCcy     // and there is support support for an alt ccy
    }    

    // helper function that tells you if you should show a mint button
    shouldShowAccesslistMint(allowMultiple = true){
        return this.hasWeb3          // web 3 is enabled
            && this.correctChain     // and we have the right network selected
            && this.account          // and the web3 wallet is connected
            && this.accesslist       // and access list is a thing
            && !this.isSold          // and it's not sold out
            && this.accesslistSaleActive // and the accesslist sale is active
            && !this.waitingOnWallet // shouldn't be able to press mint while we're waiting on a wallet interaction
            && (!this.mintRunning || allowMultiple)     // can't mint if we'd said they cannot do a mint when another mint tx is pending
    }    

}

const NFT = {
   
    // construct and return an NFT context
    async init( params){


        const context = new NFTContext();

        await context.init(params)

        return context

      },


}

export default NFT;
